import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Funding")
], -1)
const _hoisted_5 = { class: "row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label mb-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Is this research funded by an internal or external agency?")
], -1)
const _hoisted_7 = { class: "col-lg-4 fv-row" }
const _hoisted_8 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "fw-bolder fs-5 mb-0",
  for: "notFunded"
}, "Not Funded Research", -1)
const _hoisted_10 = { class: "col-lg-4 fv-row" }
const _hoisted_11 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "fw-bolder fs-5 mb-0",
  for: "external"
}, "External Agency", -1)
const _hoisted_13 = { class: "col-lg-4 fv-row" }
const _hoisted_14 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "fw-bolder fs-5 mb-0",
  for: "internal"
}, "Internal Agency", -1)
const _hoisted_16 = { class: "row mb-8" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label mb-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Please select the agency from the list")
], -1)
const _hoisted_18 = { class: "col-lg-12 fv-row" }
const _hoisted_19 = {
  key: 0,
  value: "National Science Foundation (NSF)"
}
const _hoisted_20 = {
  key: 1,
  value: "National Institutes of Health (NIH)"
}
const _hoisted_21 = {
  key: 2,
  value: "National Endowment for the Humanities (NEH)"
}
const _hoisted_22 = {
  key: 3,
  value: "Department of Defense."
}
const _hoisted_23 = {
  key: 4,
  value: "Sam.gov"
}
const _hoisted_24 = {
  key: 5,
  value: "Fogarty International Center."
}
const _hoisted_25 = {
  key: 6,
  value: "Grants.gov."
}
const _hoisted_26 = {
  key: 7,
  value: "State Agency"
}
const _hoisted_27 = {
  key: 8,
  value: "Company"
}
const _hoisted_28 = {
  key: 9,
  value: "Organization"
}
const _hoisted_29 = {
  key: 10,
  value: "Faculty Research Grant (FRG)"
}
const _hoisted_30 = {
  key: 11,
  value: "Faculty Development Grant (FDG)"
}
const _hoisted_31 = {
  key: 12,
  value: "Baker Grant"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "Others" }, "Others, please specify", -1)
const _hoisted_33 = {
  key: 0,
  class: "d-flex flex-column mb-5 mt-5 fv-row"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, " Please enter the name ", -1)
const _hoisted_35 = { class: "fv-row" }
const _hoisted_36 = { class: "d-flex flex-stack" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Is notification of IRB approval required by the granting agency?")
], -1)
const _hoisted_38 = { class: "form-check form-switch form-check-custom form-check-solid mb-7" }
const _hoisted_39 = { class: "form-check-label fw-bold text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_Field, {
              class: "form-check-input me-3",
              type: "radio",
              value: "Not Funded Research",
              modelValue: _ctx.step3.agencyType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step3.agencyType) = $event)),
              name: "agencyType"
            }, null, 8, ["modelValue"]),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_Field, {
              class: "form-check-input me-3",
              type: "radio",
              value: "External Agency",
              modelValue: _ctx.step3.agencyType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step3.agencyType) = $event)),
              name: "agencyType"
            }, null, 8, ["modelValue"]),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, [
            _createVNode(_component_Field, {
              class: "form-check-input me-3",
              type: "radio",
              value: "Internal Agency",
              modelValue: _ctx.step3.agencyType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step3.agencyType) = $event)),
              name: "agencyType"
            }, null, 8, ["modelValue"]),
            _hoisted_15
          ])
        ]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "agencyType",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "How it will be record?",
          modelValue: _ctx.step3.agencyType,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step3.agencyType) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "agencyType",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _withDirectives(_createElementVNode("select", {
            name: "agency",
            "data-control": "select2",
            "data-hide-search": "true",
            class: "form-select",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step3.agency) = $event))
          }, [
            (_ctx.step3.agencyType === 'External Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_19, " National Science Foundation (NSF) "))
              : _createCommentVNode("", true),
            (_ctx.step3.agencyType === 'External Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_20, " National Institutes of Health (NIH) "))
              : _createCommentVNode("", true),
            (_ctx.step3.agencyType === 'External Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_21, " National Endowment for the Humanities (NEH) "))
              : _createCommentVNode("", true),
            (_ctx.step3.agencyType === 'External Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_22, " Department of Defense. "))
              : _createCommentVNode("", true),
            (_ctx.step3.agencyType === 'External Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_23, " Sam.gov "))
              : _createCommentVNode("", true),
            (_ctx.step3.agencyType === 'External Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_24, " Fogarty International Center. "))
              : _createCommentVNode("", true),
            (_ctx.step3.agencyType === 'External Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_25, " Grants.gov. "))
              : _createCommentVNode("", true),
            (_ctx.step3.agencyType === 'External Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_26, " State Agency (Please enter the name of the agency) "))
              : _createCommentVNode("", true),
            (_ctx.step3.agencyType === 'External Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_27, " Company (Please enter the name of the company) "))
              : _createCommentVNode("", true),
            (_ctx.step3.agencyType === 'External Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_28, " Organization (Please enter the name of the organization) "))
              : _createCommentVNode("", true),
            (_ctx.step3.agencyType === 'Internal Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_29, " Faculty Research Grant (FRG) "))
              : _createCommentVNode("", true),
            (_ctx.step3.agencyType === 'Internal Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_30, " Faculty Development Grant (FDG) "))
              : _createCommentVNode("", true),
            (_ctx.step3.agencyType === 'Internal Agency')
              ? (_openBlock(), _createElementBlock("option", _hoisted_31, " Baker Grant "))
              : _createCommentVNode("", true),
            _hoisted_32
          ], 512), [
            [_vModelSelect, _ctx.step3.agency]
          ]),
          _createVNode(_component_Field, {
            type: "hidden",
            name: "agency",
            class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
            placeholder: "How it will be record?",
            modelValue: _ctx.step3.agency,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step3.agency) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_ErrorMessage, {
            name: "agency",
            class: "fv-plugins-message-container invalid-feedback"
          })
        ])
      ], 512), [
        [_vShow, _ctx.step3.agencyType !=`` && _ctx.step3.agencyType !=null &&  !_ctx.isNotFundedResearch ]
      ]),
      (!_ctx.isNotFundedResearch && _ctx.isShowOtherAgency)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _hoisted_34,
            _createVNode(_component_Field, {
              class: "form-control form-control-solid",
              placeholder: "Name of the others",
              name: "agencyOther",
              modelValue: _ctx.step3.agencyOther,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step3.agencyOther) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "agencyOther",
              class: "fv-plugins-message-container invalid-feedback"
            })
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("label", _hoisted_38, [
            _createVNode(_component_Field, {
              type: "checkbox",
              class: "form-check-input",
              name: "isRequiredGrant",
              value: "1",
              modelValue: _ctx.step3.isRequiredGrant,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step3.isRequiredGrant) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.step3.isRequiredGrant == "1" ? "Yes" : "No"), 1)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.isNotFundedResearch]
      ])
    ])
  ]))
}